import React, { useContext } from 'react'
import { MdLogout } from "react-icons/md";
import AuthContext from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
    const { logout } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate("/login")
    }
    return (
        <header className="bg-white shadow-lg p-4">
            <div className="flex justify-end items-center">
                
                
                <div className="flex items-center">
                    <button className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600">
                        <MdLogout size={18} onClick={handleLogout} />
                    </button>
                </div>
            </div>
        </header>
    )
}

export default Navbar